export default __webpack_public_path__ + "static/media/ingredients-healthy-foods-selection-set-up.4e66b7d3.jpg";